import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";

const json = {
  1: { // Exercise num
    unit: 'Unit 7',
    id: 'SB3-U7-P53-E1',
    audio: 'img/FriendsPlus/Page53/Audio/audio-e1-p53.mp3',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page53/E1/Key/answerKey.png',
    titleQuestion: [{ num: '1', title: 'Listen and circle the correct word. <headphone name="03" src="img/FriendsPlus/Page53/Audio/tieude-e1-p53.mp3"></headphone>', color: "#1F4199" }],
    question: {
      Write: {
        // checkUppercase: true,
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { fontWeight: 'bold' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', borderRadius: '50%' },
        limitSelect: 1,
        listWords: [
          'lions / parrots / monkeys', //0
          '23 / 32 / 17', //1
          'five / four / seven', //2
          'blue_and_green / black_and_white / yellow_and_pink', //3
          'write / read / talk', //4
        ],
        answers: ['0-8', '1-0', '2-4', '3-0', '4-8'],
        initialValue: [],
      },
      Layout: `
        <img src="img/FriendsPlus/Page53/E1/1.jpg" style="width: 100%">
        <div><b>1</b>&nbsp;Nam looks after the <span style='font-weight: bold;'>big / <span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;">little</span></span> animals.</div>
        <div><b>2</b> His favorite animals are the <input id='0' type='Circle' />.</div>
        <div><b>3</b> There are <input id='1' type='Circle' /> monkeys at the zoo.</div>
        <div><b>4</b> There are <input id='2' type='Circle' /> parrots at the zoo.</div>
        <div><b>5</b> Fred is <input id='3' type='Circle' /> .</div>
        <div><b>6</b> Fred can <input id='4' type='Circle' /> .</div>
      `,
    },
  },
  2: { // Exercise num
    unit: 'Unit 7',
    id: 'SB3-U7-P53-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page53/E2/1.jpg' }]],
  },
  3: { // Exercise num
    unit: 'Unit 7',
    id: 'SB3-U7-P53-E3',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page51/E4/Key/answerKey.png',
    isAllowSubmit: false,
    question: [],
    hideBtnFooter: true,
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page53/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page53/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/5.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page53/E3/7.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/8.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page53/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/13.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/15.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/16.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page53/E3/17.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/18.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/20.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/21.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page53/E3/22.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page53/E3/23.jpg' },
      ],
    ]
  },
  4: { // Exercise num
    unit: "Unit 7",
    id: "SB3-U7-P53-E4",
    audio: "",
    video: "",
    component: DesignUnderLine,
    hideBtnFooter: true,
    totalInput: 7,
    exerciseKey: "img/FriendsPlus/Page53/E4/Key/answerKey.png",
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page53/E4/1.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page53/E4/71.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page53/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page53/E4/4.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/5.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page53/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/7.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page53/E4/8.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page53/E4/9.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page53/E4/10.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/11.jpg', input: 6 },
        { url: 'img/FriendsPlus/Page53/E4/12.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/13.jpg', input: 7 },
        { url: 'img/FriendsPlus/Page53/E4/14.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/15.jpg', input: 8 },
        { url: 'img/FriendsPlus/Page53/E4/16.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/17.jpg', input: 9 },
        { url: 'img/FriendsPlus/Page53/E4/18.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/19.jpg', input: 10 },
        { url: 'img/FriendsPlus/Page53/E4/20.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/21.jpg', input: 11, isCorrect: true },
        { url: 'img/FriendsPlus/Page53/E4/22.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/23.jpg', input: 12, isCorrect: true },
        { url: 'img/FriendsPlus/Page53/E4/24.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page53/E4/25.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/26.jpg', input: 13, isCorrect: true },
        { url: 'img/FriendsPlus/Page53/E4/27.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/28.jpg', input: 14 },
        { url: 'img/FriendsPlus/Page53/E4/29.jpg', input: 15 },
        { url: 'img/FriendsPlus/Page53/E4/30.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/31.jpg', input: 16 },
        { url: 'img/FriendsPlus/Page53/E4/32.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/33.jpg', input: 17 },
        { url: 'img/FriendsPlus/Page53/E4/34.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/35.jpg', input: 18 },
        { url: 'img/FriendsPlus/Page53/E4/36.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/37.jpg', input: 19 },
        { url: 'img/FriendsPlus/Page53/E4/38.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/39.jpg', input: 20 },
        { url: 'img/FriendsPlus/Page53/E4/40.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/41.jpg', input: 21, isCorrect: true },
        { url: 'img/FriendsPlus/Page53/E4/42.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page53/E4/43.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/44.jpg', input: 22, isCorrect: true },
        { url: 'img/FriendsPlus/Page53/E4/45.jpg', input: 23, isCorrect: true },
        { url: 'img/FriendsPlus/Page53/E4/46.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/47.jpg', input: 24 },
        { url: 'img/FriendsPlus/Page53/E4/48.jpg', input: 25 },
        { url: 'img/FriendsPlus/Page53/E4/49.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/50.jpg', input: 26 },
        { url: 'img/FriendsPlus/Page53/E4/51.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/52.jpg', input: 27 },
        { url: 'img/FriendsPlus/Page53/E4/53.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/54.jpg', input: 28 },
        { url: 'img/FriendsPlus/Page53/E4/55.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/56.jpg', input: 29 },
        { url: 'img/FriendsPlus/Page53/E4/57.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page53/E4/58.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/59.jpg', input: 30 },
        { url: 'img/FriendsPlus/Page53/E4/60.jpg', input: 31 },
        { url: 'img/FriendsPlus/Page53/E4/61.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/62.jpg', input: 32 },
        { url: 'img/FriendsPlus/Page53/E4/63.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/64.jpg', input: 33 },
        { url: 'img/FriendsPlus/Page53/E4/65.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/66.jpg', input: 34 },
        { url: 'img/FriendsPlus/Page53/E4/67.jpg' },
        { url: 'img/FriendsPlus/Page53/E4/68.jpg', input: 35 },
        { url: 'img/FriendsPlus/Page53/E4/69.jpg', input: 36 },
        { url: 'img/FriendsPlus/Page53/E4/70.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page53/E4/72.jpg' },
      ],
    ],
  },
}

export default json;